import { theme } from '@febos-io/design';
import { useAuthContext } from '../providers';

export function SignInPage() {
  const {
    SignInForm
  } = useAuthContext();
  return (
    <theme.views.Login>
      <SignInForm />
    </theme.views.Login>
  );
}

export default SignInPage;
